import Vue from 'vue';
import Vuex from 'vuex';
import page from './modules/page';
import auth from './modules/auth';
import user from './modules/user';
import group from './modules/group-user';
import configuration from './modules/configuration';
import category from './modules/category';
import station from './modules/station';
import news from './modules/news';
import geojson from './modules/geojson';
import layer from './modules/layer';
import analyze from './modules/analyze';
import sms from './modules/sms';
import feedback from './modules/feedback';
import flood from './modules/flood';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
    modules: {
        page,
        auth,
        user,
        group,
        configuration,
        category,
        station,
        news,
        geojson,
        layer,
        analyze,
        sms,
        feedback,
        flood
    },
    strict: debug
});
